(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.initMenuDrawer();
      this.initMenuDropdowns();
    }

    initMenuDrawer() {
      const menuDrawerContainer = document.querySelector('#Details-menu-drawer-container');
      const menuDrawer = document.querySelector('#menu-drawer');

      if (menuDrawerContainer) {
        menuDrawerContainer.addEventListener('toggle', (event) => {
          const isOpen = menuDrawerContainer.hasAttribute('open');
          if (menuDrawer) {
            if (isOpen) {
              menuDrawer.classList.add('menu-drawer--active');
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  document.documentElement.style.setProperty('--header-height', `${
                    this.header.offsetHeight
                  }px`);
                });
              });
            } else {
              document.documentElement.style.setProperty('--header-height', `${
                this.header.offsetHeight
              }px`);
              setTimeout(() => {
                menuDrawer.classList.remove('menu-drawer--active');
              }, 300);
            }
          }
        });

        menuDrawer.addEventListener('click', (event) => {
          const target = event.target;
          if (target.closest('.menu-drawer__menu-item_wrapper') || target.closest('.menu-drawer__submenu')) {
            event.stopPropagation();
          }
        });
      }
    }

    initMenuDropdowns() {
      const menuItems = document.querySelectorAll('.menu-drawer__menu-item_wrapper');

      menuItems.forEach(details => {
        const summary = details.querySelector('summary');
        const submenu = details.querySelector('.menu-drawer__submenu');
        const plusIcon = summary ?. querySelector('.icon-cstm-plus');
        const minusIcon = summary ?. querySelector('.icon-cstm-minus');

// Set initial state
        if (plusIcon && minusIcon) {
          plusIcon.style.display = 'block';
          minusIcon.style.display = 'none';
        }

        if (summary && submenu) {
          details.addEventListener('toggle', (event) => {
            event.stopPropagation();

            if (details.hasAttribute('open')) {
              submenu.classList.add('submenu--open');

// Toggle icons
              if (plusIcon && minusIcon) {
                plusIcon.style.display = 'none';
                minusIcon.style.display = 'block';
              }

// Close other open submenus
              menuItems.forEach(otherDetails => {
                if (otherDetails !== details && otherDetails.hasAttribute('open')) {
                  otherDetails.removeAttribute('open');
                  otherDetails.querySelector('.menu-drawer__submenu') ?. classList.remove('submenu--open');

// Reset other icons
                  const otherPlus = otherDetails.querySelector('.icon-cstm-plus');
                  const otherMinus = otherDetails.querySelector('.icon-cstm-minus');
                  if (otherPlus && otherMinus) {
                    otherPlus.style.display = 'block';
                    otherMinus.style.display = 'none';
                  }
                }
              });
            } else {
              submenu.classList.remove('submenu--open');

// Toggle icons
              if (plusIcon && minusIcon) {
                plusIcon.style.display = 'block';
                minusIcon.style.display = 'none';
              }
            }
          });

          summary.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        }
      });
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      


      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        


        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
